module.exports = __webpack_public_path__ + "static/praise2.e1943338300cfb2ca18455dccbb2ee1a.png";